export default "__VITE_PUBLIC_ASSET__e2cf1e67__"